export default __webpack_public_path__ + "static/media/sportya-partner-club.0f54c0a4.svg";